import $ from 'jquery';
import 'core-js/es/number';
import 'core-js/es/object';
import 'core-js/modules/es.array.iterator'
import pageScripts from './pages';

import 'what-input';

require('slick-carousel/slick/slick');
require('./components/objectfitimages');

$( document ).ready( function () {
	//Require all components here.
	require( './components/foundation' );
	require( './components/header-slider' );
	require( './components/footer' );
	require( './components/menu' );
	require( './components/embed-popups' );
	require( './components/media' );
	require( './components/facebook-swiper' );
	require( './components/search-suggestions' );
	require( './components/facetwp' )
	require( './components/flexible-content/faq-archive' );
	require( './components/flexible-content/slick-slider' );

	document.body.className.replace( /-/g, '_' ).split( /\s+/ ).forEach( cls => {
		pageScripts[ cls ] && pageScripts[ cls ]();
	} );
} );
